import { Text } from '@mantine/core';
import {
  COMPANY_LEVEL_LABELS,
  normalizeCompanyLevel,
} from '../../model/companyLevel';
import { CompanyLevelMedalIcon } from '../CompanyLevelMedalIcon';
import { CompanyLevelFlex } from '../company-level-flex';
import classes from './company-level-badge.module.scss';

type CompanyLevelBadgeProps = {
  level?: string | null;
};

export const CompanyLevelBadge = ({ level }: CompanyLevelBadgeProps) => {
  const normalizedLevel = normalizeCompanyLevel(level);

  return (
    <CompanyLevelFlex className={classes.badge} level={normalizedLevel}>
      <CompanyLevelMedalIcon muted={normalizedLevel === 'none'} />
      <Text
        component='span'
        size='xs'
        c={normalizedLevel === 'none' ? 'tertiary.7' : 'primary.7'}
      >
        {COMPANY_LEVEL_LABELS[normalizedLevel]}
      </Text>
    </CompanyLevelFlex>
  );
};
